import { createElement as e } from "react";
import { App } from "sc/ui/sites/oncall/App";
import { createAppReducer } from "sc/ui/sites/oncall/reducers/app-reducer";
import { appSagas } from "sc/ui/sites/oncall/sagas/app-sagas";
import { persistConfig } from "sc/ui/sites/oncall/reducers/app-reducer";

export default ({ createConfig }) =>
  e(App, { config: createConfig(createAppReducer, appSagas, persistConfig) });



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/index.js